const SelectSensorType = ({ SensorTypes, selectedSensorType, setSelectedSensorType }) => {
    return (
        <select
        id='sensor-type-select'
        className='type-select-style'
        value={selectedSensorType}
        onChange={(e) => setSelectedSensorType(e.target.value)}
        >
            {selectedSensorType === '' ? <option value="">
                ------
            </option> : null}
            {SensorTypes.map((sensorType) => (
                <option
                    key={sensorType[1]}
                    value={sensorType[0]}
                >
                    {sensorType[1]}
                </option>
            ))}
        </select>
    );
};

export default SelectSensorType;